import { useEffect, useRef, useState } from 'react'
import type { ApplePayConfig, ApplePayInstance, ApplePayPaymentRequest } from '@recurly/recurly-js'
import logger from 'logger'
import { useIntl } from 'intl'

import { useApplePaySubmit, usePaymentFlow, useRecurly } from 'modules/payment'
import { useUser } from 'modules/user'
import { useSubscription } from 'modules/subscription'


export const useApplePayPaymentMethodButton = () => {
  const intl = useIntl()
  const { recurly } = useRecurly()
  const { submit, isProcessing } = usePaymentFlow()
  const { country } = useUser()
  const { subscription } = useSubscription()

  const [ isReady, setReady ] = useState(false)
  const applePayRef = useRef<ApplePayInstance>(null)

  const { submitApplePay } = useApplePaySubmit({ applePayRef, submit, payStep: 'Payment method update' })

  useEffect(() => {
    setReady(false)

    if (applePayRef.current) {
      applePayRef.current = null
    }

    try {
      const paymentRequest: ApplePayPaymentRequest = {
        total: {
          label: 'Total',
          amount: intl.formatPrice(subscription.nextBillingPrice, { withCurrency: false }),
        },
      }

      const config: ApplePayConfig = {
        country,
        currency: intl.currency,
        paymentRequest,
      }

      logger.info(config, '[ApplePay] config')

      const applePay = recurly.ApplePay(config)

      applePay.ready(() => {
        logger.info(`[ApplePay] ready`)
        setReady(true)
      })

      applePayRef.current = applePay
    }
    catch (error) {
      logger.error(error, '[ApplePay] initialization failed')
    }
  }, [ intl, recurly, country, subscription.nextBillingPrice ])

  return {
    submitApplePay,
    isReady,
    isProcessing,
  }
}

export default useApplePayPaymentMethodButton
